import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useIsPwa } from './useIsPwa';

export const useOpenAppRoute = () => {
  const isPwa = useIsPwa();
  const navigate = useNavigate();

  return useCallback(
    (path: string) => {
      if (isPwa) return void navigate(path);
      window.open(path, '_blank', 'noopener,noreferrer');
    },
    [isPwa, navigate],
  );
};
